// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2ffPn","item":"PaymentsMobile_item__3rawx","label":"PaymentsMobile_label__2yYTq","amount":"PaymentsMobile_amount__iAOFG"};